
    import * as React from 'react';

    const FavoriteFilled16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8.56 3.013c.76-.862 1.685-1.388 2.772-1.388 1.087 0 1.88.425 2.397 1.128.309.42.459.838.491 1.067.024.063.054.169.082.316.5 2.56-.998 5.988-6.076 9.82L8 14.128l-.226-.17c-5.078-3.833-6.576-7.261-6.076-9.821.028-.147.058-.253.064-.248.05-.297.2-.715.51-1.135.516-.703 1.31-1.128 2.396-1.128 1.087 0 2.011.526 2.773 1.389.21.239.397.49.559.744a5.92 5.92 0 01.56-.745z" /></svg>
        </div>
      );
    };

    FavoriteFilled16.displayName = 'FavoriteFilled16';

    export default FavoriteFilled16;
  